import React, { useEffect, useState } from "react";
import DashboardLayout from "@layouts/dashboard/dashboard-layout";
import { getValue, setValue } from "@utils/lodash";
import { NavLink } from "react-router-dom";
import {
  adminCreateCheckpoint,
  adminDeleteSpecificCheckpoint,
} from "@services/checkpoint.service";
import { useNavigate } from "react-router-dom";
import FilterForm from "@components/common/AddFilter/FilterForm";
import NavigationBar from "@components/NotificationBarCheckpoint/index";
import DeleteModal from "@_common/deleteModal";
import { toast } from "react-toastify";
import PaginationPage from "@components/pagination/pagination";
import SearchHeader from "@components/common/SearchHeader";
import {
  adminGetATCountriesListManagement,
  adminGetATStatesListManagement,
  adminGetCountriesListManagement,
  adminGetListManagementGroupCode,
  adminGetStatesListManagement,
  getSmartFilterATCategoryOfLawList,
  getSmartFilterATLegislationList,
  getSmartFilterATLegislationRuleList,
  getSmartFilterCategoryOfLawList,
  getSmartFilterLegislationList,
  getSmartFilterLegislationRuleList,
  getSmartFilterListManagementList,
} from "@services/list-management.service";
import Notfound from "@components/Not-Found";
import {
  adminBulkUpdateStatus,
  adminGetUsers,
  getATEvaluatorUsers,
  getATExecutorUsers,
  getATFunctionHeadUsers,
  getFunctionHeadUsers,
} from "@services/users.service";
import {
  getSelfComplianceList,
  getSelfComplianceTaskList,
  updateSelfComplianceListStatus,
} from "@services/self-compliance.service";
import Loader from "@components/common/Loader";
import { QueryRequestHelper } from "@_common/query-request-helper";
import NoAccessPage from "@components/common/NoAccess";
import { formatText } from "@_common/format-text";
import AssignTaskFilterForm from "@components/common/AddFilter/AssignTaskFilterForm";
import {
  getATChildEntityGroups,
  getChildEntityGroups,
  getEntityGroups,
} from "@services/entity-mapping.service";
import ScrollableReactTable from "@components/ScrollableDatatable";
import { downloadSelfCompliance } from "@services/self-compliance.service";
import { handleDownloadOnClick } from "@_common/downloadfile";
import { convertDate, convertDateAsString } from "@_common/date-helpers";
import FooterWrapper from "@components/common/FooterWrapper";
import CheckpointAssignedTaskNotfound from "@components/Page-Not-Found/checkpoint-assigned-task-not-found";
import MenuRepositorySvgComponent from "../../../assets/svg-components/left-menu/menurepo";
import RightMenuHeaders from "@components/common/RightMenuHeaders";
import ModuleFilter from "@components/common/ModuleFilter";
import { getSpecificCategoryLawById } from "@_common/global-apis";
import { countKeysWithValues } from "@_common/text-helpers";
import SubmenuArrowDownSvgComponent from "../../../assets/svg-components/left-menu/submenu-arrow-down";
import {
  downloadAssignedTaskReports,
  downloadSelfComplianceReports,
} from "@services/import.service";
interface ICheckpointActiveProps {}

const AssignedTasks: React.FunctionComponent<ICheckpointActiveProps> = (
  props: any,
) => {
  let navigate = useNavigate();

  /* -------------------------------------------------------------------------- */
  /*                               UseState Section                             */
  /* -------------------------------------------------------------------------- */

  const [isLoading, setIsLoading] = React.useState(true);
  const [list, setList] = React.useState<[]>([]);
  const [isFilterVisible, setFilterVisibility] = React.useState(false);

  const [filterIsOpen, setFilterIsOpen] = useState(false);

  const handleFilter = () => {
    setFilterIsOpen(!filterIsOpen);
  };

  const [filterOptions] = useState([
    { value: "DRAFT", label: "Draft" },
    { value: "ACTIVE", label: "Active" },
    { value: "ARCHIVED", label: "Archived" },
  ]);
  /* -------------------------------------------------------------------------- */
  /*                               UseEffect Section                            */
  /* -------------------------------------------------------------------------- */

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    getPEComplianceList();
    if (Object.keys(params).length === 0 && props.permissionAPITriggered) {
      getData();
      getCountriesList();
      getSmartFilterList();
      getHeaderList(paramsObj, 0);
      getExecutorList("", "");
      getEvaluator("", "");
      getFunctionHead("", "");
      getFrequency("", "");

      getCategoryLawList("", "", "");
      getLegislationList("", "", "", "");
      getLegislationRuleList("", "", "");
    }
  }, [props.permissionAPITriggered]);

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (Object.keys(params).length > 0 && props.permissionAPITriggered) {
      getData();
      getCountriesList();
      getSmartFilterList();
      getExecutorList("", getValue(params, `executor`, ""));
      getEvaluator("", getValue(params, `evaluator`, ""));
      getFunctionHead("", getValue(params, `function_head`, ""));
      getFrequency(getValue(params, `frequency_id`, ""), "");

      if (params.page_no) {
        setPage_no(parseInt(params.page_no));
      }
      if (params.search_text) {
        setSearchInput(params.search_text);
        setShowSearchTextbox(true);
      }
      if (params.limit) {
        setLimit(parseInt(params.limit));
      }
      setRequest({
        country_id: getValue(params, `country_id`, "101"),
        state_id: getValue(params, `state_id`, ""),
        category_of_law_id: getValue(params, `category_of_law_id`, ""),
        legislation_id: getValue(params, `legislation_id`, ""),
        legislation_rule_id: getValue(params, `legislation_rule_id`, ""),
        executor: getValue(params, `executor`, ""),
        evaluator: getValue(params, `evaluator`, ""),
        function_head: getValue(params, `function_head`, ""),
      });
      if (
        getValue(params, `country_id`, "") ||
        getValue(params, `level1`, "")
      ) {
        setFilterVisibility(true);
        getStatesList(getValue(params, `country_id`, ""));
      }
      if (
        getValue(params, `state_id`, "") ||
        getValue(params, `category_of_law_id`, "") ||
        getValue(params, `legislation_id`, "")
      ) {
        getCategoryLawList(
          "",
          getValue(params, `state_id`, ""),
          getValue(params, `category_of_law_id`, ""),
        );
        getLegislationList(
          "",
          getValue(params, `state_id`, ""),
          getValue(params, `category_of_law_id`, ""),
          getValue(params, `legislation_id`, ""),
        );
        getLegislationRuleList(
          "",
          getValue(params, `legislation_id`, ""),
          getValue(params, `legislation_rule_id`, ""),
        );
      } else {
        getCategoryLawList("", "", "");
        getLegislationList("", "", "", "");
        getLegislationRuleList("", "", "");
      }
      if (getValue(params, `smart_filter_tags`, "")) {
        getSmartFilterList();
        // getLegislationRuleList(getValue(params, `legislation_id`, ""));
      }
      let paramObj: any = {};
      //finding only levels params if it presented in URL
      for (let i = 1; i < 11; i++) {
        if (getValue(params, `level${i}`, "")) {
          paramObj[`level${i}`] = getValue(params, `level${i}`, "");
        }
      }
      setParamsObj(paramObj);
      getHeaderList(paramObj, 0);
    }
  }, [window.location.href, props.permissionAPITriggered]);
  /* -------------------------------------------------------------------------- */
  /*                               API Section                                  */
  /* -------------------------------------------------------------------------- */
  const getPayload = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let selectedIDs: any = urlSearchParams.getAll("smart_filter_tags[]");
    let compliance_task_ids: any = urlSearchParams.getAll(
      "compliance_task_ids[]",
    );

    let payload: any = {
      page_no: params.page_no ? parseInt(params.page_no) : 1,
      page_size: params.limit ? parseInt(params.limit) : limit,
      search_text: params.search_text,
      sort_by: params.sort_by,
      compliance_status: getValue(params, `compliance_status`, ""),
      compliance_type_id: getValue(params, `compliance_type_id`, ""),
      self_compliance_task_ids: compliance_task_ids,
      smart_filter_tags: selectedIDs,
      frequency_id: getValue(params, `frequency_id`, ""),
      activation_status: getValue(params, `activation_status`, ""),
      // status: "active",
    };
    return { ...payload };
  };

  const [licenseIDs, setLicenseIDs] = useState([]);
  const getData = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    // let selectedIDs: any = urlSearchParams.getAll("smart_filter_tags[]");

    // let payload: any = {
    //   page_no: params.page_no ? parseInt(params.page_no) : 1,
    //   page_size: params.limit ? parseInt(params.limit) : limit,
    //   search_text: params.search_text,
    //   // status: "active",
    //   sort_by: params.sort_by,
    //   country_id: parseInt(getValue(params, `country_id`, "")),
    //   state_id: parseInt(getValue(params, `state_id`, "")),
    //   category_of_law_id: await getSpecificCategoryLawById(
    //     getValue(params, `category_of_law_id`, "")
    //   ),
    //   legislation_id: getValue(params, `legislation_id`, ""),
    //   legislation_rule_id: getValue(params, `legislation_rule_id`, ""),
    //   event_id: parseInt(getValue(params, `event_id`, "")),
    //   sub_event_id: parseInt(getValue(params, `sub_event_id`, "")),
    //   smart_filter_tags: selectedIDs,
    //   compliance_type_id: getValue(params, `compliance_type_id`, ""),
    //   frequency_id: getValue(params, `frequency_id`, ""),
    //   is_configured: getValue(params, `is_configured`, ""),
    //   activation_status: getValue(params, `activation_status`, ""),
    //   evaluator: getValue(params, `evaluator`, ""),
    //   executor: getValue(params, `executor`, ""),
    //   function_head: getValue(params, `function_head`, ""),
    // };

    let payload: any = {
      country_id: parseInt(getValue(params, `country_id`, "")),
      state_id: parseInt(getValue(params, `state_id`, "")),
      // category_of_law_id: await getSpecificCategoryLawById(
      //   getValue(params, `category_of_law_id`, "")
      // ),
      category_of_law_id: getValue(params, `category_of_law_id`, ""),
      legislation_id: getValue(params, `legislation_id`, ""),
      legislation_rule_id: getValue(params, `legislation_rule_id`, ""),
      events_id: parseInt(getValue(params, `events_id`, "")),
      sub_events_id: parseInt(getValue(params, `sub_events_id`, "")),
      executor: getValue(params, `executor`, ""),
      evaluator: getValue(params, `evaluator`, ""),
      function_head: getValue(params, `function_head`, ""),
      is_configured: getValue(params, `is_configured`, ""),
      // status: "active",
    };

    Object.keys(payload).forEach((key) => {
      if (!payload[key] || payload[key] === undefined) {
        delete payload[key];
      }
    });
    let levelObj: any = {};
    //finding only levels params if it presented in URL
    for (let i = 1; i < 11; i++) {
      if (getValue(paramsObj, `level${i}`, "")) {
        levelObj[`level_${i}`] = getValue(paramsObj, `level${i}`, "").split(
          "_",
        )[0];
      }
    }
    // let queryRequest = QueryRequestHelper({ ...payload, ...levelObj });
    let payloadObj = await getPayload();
    let queryRequest = QueryRequestHelper({
      ...payload,
      ...levelObj,
      ...payloadObj,
    });

    try {
      setIsLoading(true);
      let resp = await getSelfComplianceList(queryRequest);
      // let resp = await adminGetUsers(queryRequest);
      if (resp) {
        setList(
          getValue(resp, `data.self_compliances`, []).map((item: any) => {
            const levels = [];
            for (let i = 1; i <= 10; i++) {
              const level = item[`level_${i}`];
              if (level) {
                levels.push(level);
              }
            }
            if (levels.length === 0) return null;
            const unitName = levels[levels.length - 2].entity_name;
            return {
              ...item,
              checkpoint_id: getValue(item, `checkpoint.checkpoint_id`, ""),
              category_of_lawName: getValue(item, `category_of_law.text`, ""),
              compliance_typeName: getValue(item, `compliance_type.text`, ""),
              frequencyName: getValue(item, `checkpoint.frequency.text`, ""),
              compliance_activity: getValue(
                item,
                `checkpoint.compliance_activity`,
                "",
              ),
              legislationName: getValue(
                item,
                `checkpoint.legislation.legislation_name`,
                "",
              ),
              reference: getValue(item, `checkpoint.reference`, ""),
              who: getValue(item, `checkpoint.who`, ""),
              when: getValue(item, `checkpoint.when`, ""),
              frequency: getValue(item, `checkpoint.frequency.text`, ""),
              legislation_ruleName: getValue(
                item,
                `checkpoint.legislation_rule.rule_name`,
                "",
              ),
              activation_status: formatText(
                getValue(item, `activation_status`, ""),
              ),
              configure: getValue(item, `is_configured`, "")
                ? "Configured"
                : "Not Configured",
              impact: getValue(item, `impact.text`, ""),
              executor: getValue(item, `executor.email`, ""),
              evaluator: getValue(item, `evaluator.email`, ""),
              function_head: getValue(item, `function_head.email`, ""),
              unit_name: unitName,
            };
          }),
        );
        let licenseIDs = getValue(resp, `data.checkpoints`, []).filter(
          (item: object) =>
            getValue(item, `compliance_type.text`, "") === "License",
        );
        setLicenseIDs(
          getValue(licenseIDs, `length`, 0) > 0
            ? licenseIDs.map((item: any) => item.id)
            : [],
        );
        setTotalCount(getValue(resp, `data.pagination.total`, 0));
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  const handleUpdateStatus = async (value: string) => {
    try {
      let payload = {
        ids: selectedIDs,
        activation_status: value,
      };
      let resp = await updateSelfComplianceListStatus(payload);
      if (resp) {
        toast.success(getValue(resp, `message`, ""));
        setSelectedIDs([]);
        getData();
      }
    } catch (error) {}
  };
  /* -------------------------------------------------------------------------- */
  /*                               Search section                               */
  /* -------------------------------------------------------------------------- */
  const [showSearchTextbox, setShowSearchTextbox] = useState(false);
  const [search_text, setSearchInput] = useState<any>("");

  const toggleSearch = () => {
    setShowSearchTextbox((prevState) => !prevState);
  };
  const toggleSearchClose = () => {
    setSearchInput("");
    toggleSearch();
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (params.search_text) {
      delete params.search_text;
      let payload: any = { ...params };
      // removing null values
      let queryRequest = QueryRequestHelper(payload);
      navigate(`${window.location.pathname}?${queryRequest}`);
      getData();
    }
  };
  const handleChangeSearch = async (e: any) => {
    setSearchInput(e.target.value);
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      ...params,
      page_no: 1,
      search_text: e.target.value,
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
    if (!e.target.value) {
      getData();
    }
  };
  const [selectedIDs, setSelectedIDs] = useState<any>([]);
  const getTableState = (value: object) => {
    let selectedIndexList = Object.keys(
      getValue(value, `selectedRowIds`, {}),
    ).map((item) => parseInt(item));
    let selectedIds =
      list.length > 0
        ? list.filter((_item: object, index: number) =>
            selectedIndexList.includes(index),
          )
        : [];
    if (selectedIds.length > 0) {
      setSelectedIDs(
        selectedIds.map((item: object) => getValue(item, `id`, "")),
      );
    } else {
      setSelectedIDs([]);
    }
  };
  const getTrProps = (rowInfo: any) => {
    if (getValue(rowInfo, `id`, "")) {
      return {
        style: {
          //   background:  'red',
          //   color: 'black'
        },
      };
    }
    return {};
  };
  /* -------------------------------------------------------------------------- */
  /*                                 Delete section                             */
  /* -------------------------------------------------------------------------- */

  const [deleteValue, setDeleteValue] = useState("");
  const [deleteId, setDeleteId] = useState("");
  // const handleDeleteFun = (id: string, value: string) => {
  // 	setDeleteValue(value);
  // 	setDeleteId(id);
  // 	handleDelete();
  // };
  const [isDelete, setIsDelete] = useState(false);
  const handleDelete = () => {
    setIsDelete(!isDelete);
  };

  const handleDeleteFunction = async () => {
    try {
      let resp = await adminDeleteSpecificCheckpoint(deleteId);
      if (resp) {
        toast.success(getValue(resp, `message`, ""));
        handleDelete();
        getData();
      }
    } catch (error) {}
  };

  /* -------------------------------------------------------------------------- */
  /*                               Onchange section                             */
  /* -------------------------------------------------------------------------- */

  // const handleChangeSortBy = (value: string) => {
  // 	const urlSearchParams = new URLSearchParams(window.location.search);
  // 	const params = Object.fromEntries(urlSearchParams.entries());
  // 	params.sort_by = value;
  // 	props.history.push({
  // 		pathname: window.location.pathname,
  // 		query: params,
  // 	});
  // };

  // const handleChangeStatus = (value: string) => {
  // 	const urlSearchParams = new URLSearchParams(window.location.search);
  // 	const params = Object.fromEntries(urlSearchParams.entries());
  // 	params.status = value;
  // 	props.history.push({
  // 		pathname: window.location.pathname,
  // 		query: params,
  // 	});
  // };
  /* -------------------------------------------------------------------------- */
  /*                               Pagination section                           */
  /* -------------------------------------------------------------------------- */

  const [totalCount, setTotalCount] = useState(0);
  const [limit, setLimit] = useState(100);
  const [page_no, setPage_no] = useState(1);

  const handleChangePagination = (page_no: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload = {
      ...params,
      page_no: page_no,
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
  };

  const handleChangeLimit = (limit: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      ...params,
      limit: limit,
      page_no: "1",
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
  };

  const rowClick = (obj: object) => {
    // console.log(getValue(obj,`original`,''))
    // navigate(`/support/detail/${getValue(obj,`original.id`,'')}`)
  };
  const columns = React.useMemo(
    () => [
      {
        Header: "Checkpoint ID",
        accessor: "checkpoint_id",
        width: 120,
        Cell: ({ row }: any) => {
          return (
            <NavLink to={`#`}>
              {getValue(row, `original.checkpoint.checkpoint_id`, "")}
            </NavLink>
          );
        },
      },

      // {
      // 	Header: "Category of Law",
      // 	accessor: "category_of_lawName",
      // 	width: 250,
      // },
      {
        Header: "Legislation",
        accessor: "legislationName",
        width: 300,
      },
      {
        Header: "Rule",
        accessor: "legislation_ruleName",
        width: 250,
      },
      {
        Header: "Reference",
        accessor: "reference",
        width: 250,
      },
      {
        Header: "Who",
        accessor: "who",
        width: 100,
      },
      {
        Header: "When",
        accessor: "when",
        width: 180,
      },
      {
        Header: "Activity",
        accessor: "compliance_activity",
        width: 350,
        Cell: ({ row }) => {
          const complianceActivity = getValue(
            row.original,
            `compliance_activity`,
            "",
          );

          const maxCharCount = 100;
          const [showFullContent, setShowFullContent] = useState(false);

          const toggleContent = (e: any) => {
            e.stopPropagation();
            setShowFullContent(!showFullContent);
          };

          const truncatedContent = complianceActivity
            ? complianceActivity.slice(0, maxCharCount)
            : "";
          return (
            <div>
              {showFullContent ? complianceActivity : truncatedContent}
              {getValue(complianceActivity, `length`, 0) > maxCharCount && (
                <span onClick={toggleContent}>
                  {showFullContent ? (
                    <span style={{ color: "#276ef1" }}>
                      {" "}
                      View less{" "}
                      <span
                        style={{
                          transform: "rotate(180deg)",
                          display: "inline-block",
                        }}
                      >
                        {" "}
                        <SubmenuArrowDownSvgComponent color="#276ef1" />{" "}
                      </span>
                    </span>
                  ) : (
                    <span>
                      {" "}
                      ...{" "}
                      <span style={{ color: "#276ef1" }}>
                        View more{" "}
                        <SubmenuArrowDownSvgComponent color="#276ef1" />{" "}
                      </span>
                    </span>
                  )}
                </span>
              )}
            </div>
          );
        },
      },
      {
        Header: "Impact",
        accessor: "impact",
        width: 100,
      },
      {
        Header: "Unit Name",
        accessor: "unit_name",
        width: 100,
      },
      {
        Header: "Executor",
        accessor: "executor",
        width: 100,
      },
      {
        Header: "Evaluator",
        accessor: "evaluator",
        width: 100,
      },
      {
        Header: "Function Head",
        accessor: "function_head",
        width: 100,
      },
      {
        Header: "Frequency",
        accessor: "frequency",
        width: 100,
      },
      {
        Header: "Configure Status",
        accessor: "configure",
        width: 120,
      },
      {
        Header: "Active Status",
        accessor: "activation_status",
        width: 100,
      },

      // {
      // 	Header: "Action",
      // 	width: 250,
      // 	Cell: ({ row }: any) => {
      // 		return (
      // 			<>
      // 				<Button
      // 					color="primary"
      // 					onClick={() => handleEdit(row.original.id)}
      // 				>
      // 					Edit
      // 				</Button>
      // 				&nbsp;&nbsp;&nbsp;
      // 				<Button
      // 					color="danger"
      // 					onClick={() =>
      // 						handleDeleteFun(row.original.id, row.values.checkpoint_id)
      // 					}
      // 				>
      // 					Delete
      // 				</Button>
      // 			</>
      // 		);
      // 	},
      // },
    ],
    [],
  );
  /* -------------------------------------------------------------------------- */
  /*                              Navigation Routes                             */
  /* -------------------------------------------------------------------------- */

  const handleNavigate = (route: string) => {
    let payload: any = {};
    if (route === "release-to-vendor") {
      payload = {
        checkpoint_id: selectedIDs,
      };
    }
    if (route === "assign-to-PE") {
      payload = {
        checkpoint_id: selectedIDs,
      };
    }
    if (route === "add-to-tracker") {
      payload = {
        checkpoint_id: selectedIDs,
      };
    }
    if (route === "assign-task") {
      payload = {
        checkpoint_id: selectedIDs,
      };
    }
    let queryRequest = QueryRequestHelper(payload);
    navigate(`/checkpoint/${route}?${queryRequest}`);
  };
  const [permissionLoading, setPermissionLoading] = React.useState(true);
  const handleChangeStatus = (name: string, value: string) => {
    if (value) {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());
      let payload = {
        ...params,
        [name]: value,
        page_no: 1,
      };
      let queryRequest = QueryRequestHelper(payload);
      navigate(`${window.location.pathname}?${queryRequest}`);
    } else {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());
      let payload = {
        ...params,
        [name]: "",
        page_no: 1,
      };
      let queryRequest = QueryRequestHelper(payload);
      navigate(`${window.location.pathname}?${queryRequest}`);
    }
  };
  /* -------------------------------------------------------------------------- */
  /*                                  Smart Filters                             */
  /* -------------------------------------------------------------------------- */
  const [request, setRequest] = useState<any>({
    country_id: "101",
    state_id: "",
    category_of_law_id: "",
    legislation_id: "",
    legislation_rule_id: "",
    event_id: "",
    sub_event_id: "",
    executor: "",
    evaluator: "",
    function_head: "",
  });
  useEffect(() => {
    getStatesList(request.country_id);
  }, [request.country_id]);

  const [countryList, setCountryList] = useState([]);
  const [states, setStates] = useState([]);
  const [smartFilterList, setSmartFilterList] = useState([]);
  const [selectedSmartFilterIds, setSelectedSmartFilterIds] = useState<any>([]);
  const handleChangeSelectMulti = (e: any) => {
    setSelectedSmartFilterIds(e);
  };

  const reset = () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    setParamsObj({});
    let payload: any = {
      page_no: params.page_no,
      search_text: getValue(params, `search_text`, ""),
      limit: getValue(params, `limit`, ""),
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
    setFilterVisibility(false);
    getData();
    reset1();
  };
  const [resetInput, setResetInput] = useState(false);
  const reset1 = () => {
    setRequest({
      ...request,
      // country_id: "",
      state_id: "",
      category_of_law_id: "",
      legislation_id: "",
      legislation_rule_id: "",
      event_id: "",
      sub_event_id: "",
      executor: "",
      evaluator: "",
      function_head: "",
    });
    setSelectedSmartFilterIds([]);
    setResetInput(true);
    // setFilterVisibility(false);
  };

  const getSmartFilterList = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    let selectedIDs: any = urlSearchParams.getAll("smart_filter_tags[]");

    try {
      let resp = await adminGetListManagementGroupCode("smart-filter");
      if (resp) {
        let list =
          getValue(resp, `data.listItems.length`, 0) > 0
            ? getValue(resp, `data.listItems`, []).filter((item: object) =>
                getValue(item, `is_active`, ""),
              )
            : [];
        let obj = list.map((item: object) => ({
          id: getValue(item, `id`, ""),
          is_active: getValue(item, `is_active`, ""),
          text: getValue(item, `text`, ""),
          value: getValue(item, `text`, ""),
          label: getValue(item, `text`, ""),
        }));
        setSmartFilterList(obj);
        if (getValue(selectedIDs, `length`, 0) > 0) {
          let arr: [] | any = [];
          selectedIDs.map((item: object) => {
            let filtered = obj.filter((ob: any) => ob.id == item);
            if (getValue(filtered, `length`, 0) > 0) {
              arr.push(filtered[0]);
            }
          });
          setSelectedSmartFilterIds(arr);
        }
      } else {
      }
    } catch (error) {}
  };

  const [peComplianceList, setPeComplianceList] = useState([]);
  const getPEComplianceList = async () => {
    try {
      let resp = await adminGetListManagementGroupCode("compliance-type");
      if (resp) {
        let list =
          getValue(resp, `data.listItems.length`, 0) > 0
            ? getValue(resp, `data.listItems`, []).filter((item: object) =>
                getValue(item, `is_active`, ""),
              )
            : [];
        let obj = list.map((item: object) => ({
          id: getValue(item, `id`, ""),
          is_active: getValue(item, `is_active`, ""),
          text: getValue(item, `text`, ""),
          value: getValue(item, `text`, ""),
          label: getValue(item, `text`, ""),
        }));
        setPeComplianceList(obj);
      } else {
      }
    } catch (error) {}
  };

  /* ---------------------------  Country  ----------------------------- */
  const getCountriesList = async () => {
    try {
      let payload = await getPayload();
      let queryRequest = QueryRequestHelper(payload);
      let resp = await adminGetATCountriesListManagement(queryRequest);
      // let resp = await adminGetCountriesListManagement();
      if (resp) {
        setCountryList(
          getValue(resp, `data`, []).map((item: object) => ({
            ...item,
            id: getValue(item, `country_id`, ""),
            value: getValue(item, `country_name`, ""),
            label: getValue(item, `country_name`, ""),
          })),
        );
      } else {
      }
    } catch (error) {}
  };

  /* ---------------------------  States  ----------------------------- */
  const getStatesList = async (countryId: number) => {
    if (countryId) {
      let payload = await getPayload();
      let queryRequest = QueryRequestHelper({ ...payload, country: countryId });
      try {
        let resp = await adminGetATStatesListManagement(queryRequest);
        // let resp = await adminGetStatesListManagement(countryId);
        if (resp) {
          setStates(
            getValue(resp, `data`, []).map((item: object) => ({
              ...item,
              id: getValue(item, `state_id`, ""),
              value: getValue(item, `state_name`, ""),
              label: getValue(item, `state_name`, ""),
            })),
          );
        } else {
        }
      } catch (error) {}
    } else {
      setValue(request, `state_id`, "");
      setRequest({ ...request });
    }
  };

  /* ---------------------------  Category Of Law  ----------------------------- */
  const [categoryOfLawList, setCategoryOfLawList] = useState([]);
  const [categoryLawLoading, setCategoryLawLoading] = useState(false);
  const getCategoryLawList = async (
    value: string,
    state_id: string,
    id: string,
  ) => {
    if (state_id || getValue(request, `state_id`, "")) {
      setResetInput(false);
      try {
        setResetInput(false);
        setCategoryLawLoading(true);
        let payload = {
          page_no: 1,
          page_size: 10,
          search_text: value,
          state_id: state_id ? state_id : getValue(request, `state_id`, ""),
          // state_id: state_id,
          country_id: getValue(request, `country_id`, ""),
          id: id,
        };
        // let queryRequest = QueryRequestHelper(payload);
        let payloadObj = await getPayload();
        let queryRequest = QueryRequestHelper({ ...payload, ...payloadObj });
        let resp = await getSmartFilterATCategoryOfLawList(queryRequest);
        // let resp = await getSmartFilterCategoryOfLawList(queryRequest);
        if (resp) {
          setCategoryOfLawList(
            getValue(resp, `data`, []).map((item: object) => ({
              ...item,
              id: getValue(item, `category_of_law_id`, ""),
              // id: getValue(item, `id`, ""),
              value: getValue(item, `category_of_law_text`, ""),
              label: getValue(item, `category_of_law_text`, ""),
            })),
          );
          setCategoryLawLoading(false);
          setValue(request, `category_of_law_id`, "");
        } else {
          setCategoryLawLoading(false);
        }
      } catch (error) {
        setCategoryLawLoading(false);
      }
    } else {
      if (!value) {
        setValue(request, `category_of_law_id`, "");
        setValue(request, `legislation_id`, "");
        setValue(request, `legislation_rule_id`, "");
        setLegislationList([]);
      }
    }
  };

  /* ---------------------------  Legislation  ----------------------------- */
  const [legislationList, setLegislationList] = useState([]);
  const [legislationLoading, setLegislationLoading] = useState(false);
  const getLegislationList = async (
    value: string,
    state_id: "",
    category_of_law_id: string,
    id: string,
  ) => {
    if (category_of_law_id || getValue(request, `category_of_law_id`, "")) {
      try {
        setResetInput(false);
        setLegislationLoading(true);
        let payload = {
          page_no: 1,
          page_size: 10,
          search_text: value,
          category_of_law_id: category_of_law_id
            ? category_of_law_id
            : getValue(request, `category_of_law_id`, ""),
          state_id: state_id ? state_id : getValue(request, `state_id`, ""),
          // state_id: state_id,
          id: id,
          country_id: getValue(request, `country_id`, ""),
        };
        // let queryRequest = QueryRequestHelper(payload);

        let payloadObj = await getPayload();
        let queryRequest = QueryRequestHelper({ ...payload, ...payloadObj });
        let resp = await getSmartFilterATLegislationList(queryRequest);
        if (resp) {
          setLegislationList(
            getValue(resp, `data`, []).map((item: object) => ({
              ...item,
              id: getValue(item, `legislation_id`, ""),
              value: getValue(item, `legislation_legislation_name`, ""),
              label: getValue(item, `legislation_legislation_name`, ""),
            })),
          );
          setLegislationLoading(false);
          setValue(request, `id`, "");
        } else {
          setLegislationLoading(false);
        }
      } catch (error) {
        setLegislationLoading(false);
      }
      if (!value) {
        setValue(request, `legislation_id`, "");
        setValue(request, `legislation_rule_id`, "");
        setRuleList([]);
      }
    }
  };

  /* ---------------------------  Legislation Rule  ----------------------------- */
  const [ruleList, setRuleList] = useState([]);
  const [legislationRuleLoading, setLegislationRuleLoading] = useState(false);
  const getLegislationRuleList = async (
    value: string,
    legislation_id: string,
    id: string,
  ) => {
    if (legislation_id || getValue(request, `legislation_id`, "")) {
      try {
        setResetInput(false);
        setLegislationRuleLoading(true);
        let payload = {
          page_no: 1,
          page_size: 10,
          search_text: value,
          legislation_id: legislation_id
            ? legislation_id
            : getValue(request, `legislation_id`, ""),
          id: id,
          state_id: getValue(request, `state_id`, ""),
          country_id: getValue(request, `country_id`, ""),
          category_of_law_id: getValue(request, `category_of_law_id`, ""),
        };
        // let queryRequest = QueryRequestHelper(payload);
        let payloadObj = await getPayload();
        let queryRequest = QueryRequestHelper({ ...payload, ...payloadObj });
        let resp = await getSmartFilterATLegislationRuleList(queryRequest);
        if (resp) {
          setRuleList(
            getValue(resp, `data`, []).map((item: object) => ({
              ...item,
              id: getValue(item, `legislation_rule_id`, ""),
              value: getValue(item, `legislation_rule_rule_name`, ""),
              label: getValue(item, `legislation_rule_rule_name`, ""),
            })),
          );
          setLegislationRuleLoading(false);
          setValue(request, `legislation_rule_id`, "");
        } else {
          setLegislationRuleLoading(false);
        }
      } catch (error) {
        setLegislationRuleLoading(false);
      }
      if (!value) {
        setValue(request, `legislation_rule_id`, "");
      }
    }
  };

  // /* ---------------------------  Entity Mapping Filters  ----------------------------- */

  // const [headerList, setHeaderList] = useState([]);
  // const [headerLoading, setHeaderLoading] = useState(false);
  // const [levelObj, setLevelObj] = useState<any>({});
  // const [paramsObj, setParamsObj] = useState<any>({});

  // const getHeaderList = async (paramsObj: any, index: number) => {
  //   const urlSearchParams = new URLSearchParams(window.location.search);
  //   const params = Object.fromEntries(urlSearchParams.entries());
  //   let payload: any = {
  //     status: params.status ? params.status : "",
  //     sort_by: params.sort_by,
  //   };
  //   let queryRequest = QueryRequestHelper(payload);
  //   try {
  //     let resp = await getEntityGroups(queryRequest);
  //     if (resp) {
  //       setHeaderList(getValue(resp, `data.entityGroups`, []));
  //       var result: any = {};
  //       for (
  //         let i = 0;
  //         i < getValue(resp, `data.entityGroups.length`, 0);
  //         i++
  //       ) {
  //         result[
  //           `${getValue(resp, `data.entityGroups[${i}].group_level`, "")}`
  //         ] = { [getValue(resp, `data.entityGroups[${i}].id`, "")]: {} };
  //       }
  //       if (Object.keys(levelObj).length === 0) {
  //         for (let x in result) {
  //           let keys = Object.keys(result[x])[0];
  //           levelObj[keys] = {};
  //         }
  //       }
  //       let list =
  //         Object.values(paramsObj).length > 0 ? Object.values(paramsObj) : [];
  //       if (getValue(list, `length`, 0) > 0) {
  //         getEntityList(
  //           getValue(paramsObj, `level1`, "").split("_")[1],

  //           `level${getValue(
  //             resp,
  //             `data.entityGroups[${0}].group_level`,
  //             ""
  //           )}` === `level1`
  //             ? ""
  //             : getValue(paramsObj, `level1`, "").split("_")[0],
  //           ""
  //         );
  //         list.map((item: any, _index: number) => {
  //           let findNextLevelInfo = getValue(
  //             resp,
  //             `data.entityGroups`,
  //             []
  //           ).filter(
  //             (ite: any) => ite.group_level === parseInt(item.split("_")[2]) + 1
  //           );
  //           return getEntityList(
  //             getValue(findNextLevelInfo, `[${0}].id`, ""),
  //             item.split("_")[0],
  //             ""
  //           );
  //         });
  //       } else {
  //         getEntityList(
  //           getValue(resp, `data.entityGroups[${0}].id`, ""),
  //           null,
  //           ""
  //         );
  //       }
  //       setHeaderLoading(false);
  //     } else {
  //       setHeaderLoading(false);
  //     }
  //   } catch (error) {
  //     setHeaderLoading(false);
  //   }
  // };

  // const [childEntityList, setChildEntityList] = useState<any>({});
  // const [childEntityLoading, setChildEntityLoading] = useState(false);
  // const getEntityList = async (
  //   id: string,
  //   entity_parent: any,
  //   search_text: string
  // ) => {
  //   if (id) {
  //     let payload = {
  //       entity_group: id,
  //       entity_parent: entity_parent,
  //       limit: 10,
  //       search_text: search_text,
  //     };
  //     let queryRequest = QueryRequestHelper(payload);
  //     setChildEntityLoading(true);
  //     try {
  //       let resp = await getChildEntityGroups(queryRequest);
  //       if (resp) {
  //         levelObj[id] = getValue(resp, `data.entityMapping`, []).map(
  //           (item: any) => ({
  //             ...item,
  //             value: getValue(item, `entity_name`, ""),
  //             label: getValue(item, `entity_name`, ""),
  //           })
  //         );
  //         setLevelObj({ ...levelObj });
  //         setChildEntityLoading(false);
  //       } else {
  //         setChildEntityLoading(false);
  //       }
  //     } catch (error) {
  //       setChildEntityLoading(false);
  //     }
  //   } else {
  //     // toast.error("You have Reached Maximum Levels");
  //   }
  // };

  // const handleClickEntity = (
  //   entity_id: any,
  //   group_id: any,
  //   group_level: any,
  //   headerIndex: number
  // ) => {
  //   //user selected level
  //   let userLevel = `${entity_id}_${group_id}_${group_level}`;
  //   let payload = { ...paramsObj };
  //   let selectedLevels =
  //     Object.values(payload).length > 0 ? Object.values(payload) : [];
  //   if (!selectedLevels.includes(userLevel)) {
  //     // appending child entity list that are presented in URL Params
  //     var result = Object.entries(childEntityList);
  //     var myNewArray: any =
  //       getValue(result, `length`, 0) > 0
  //         ? result.filter(function (item, index) {
  //             return index + 1 <= group_level;
  //           })
  //         : [];
  //     let obj: any = {};
  //     if (getValue(myNewArray, `length`, 0) > 0) {
  //       myNewArray.map((item: any) => {
  //         obj[item[0]] = item[1];
  //       });
  //     }
  //     setChildEntityList(obj);

  //     //deleting params if grater then current level selected by the user
  //     for (let i = group_level + 1; i < 10; i++) {
  //       delete paramsObj[`level${i}`];
  //     }

  //     // replacing url param if it have same group level / else we can add new one
  //     let checkIfAlreadyExist =
  //       Object.keys(payload).length > 0
  //         ? Object.keys(payload).includes(`level${group_level}`)
  //         : false;
  //     if (checkIfAlreadyExist) {
  //       delete paramsObj[`level${group_level}`];
  //       let obj = {
  //         ...paramsObj,
  //         // checkpoint_id: selectedIDs,
  //         [`level${group_level}`]: `${entity_id}_${group_id}_${group_level}`,
  //       };
  //       setParamsObj(obj);
  //       getHeaderList(obj, headerIndex);
  //       // let queryRequest = QueryRequestHelper(obj);
  //       // navigate(`${window.location.pathname}?${queryRequest}`);
  //     } else {
  //       let obj = {
  //         ...paramsObj,
  //         // checkpoint_id: selectedIDs,
  //         [`level${group_level}`]: `${entity_id}_${group_id}_${group_level}`,
  //       };
  //       setParamsObj(obj);
  //       getHeaderList(obj, headerIndex);
  //       // let queryRequest = QueryRequestHelper(obj);
  //       // navigate(`${window.location.pathname}?${queryRequest}`);
  //     }
  //   } else {
  //     // toast.error("Already selected");
  //   }
  // };
  // const handleChangeEntity = (
  //   val: string,
  //   entity_group: string,
  //   parent_level: any,
  //   index: number
  // ) => {
  //   let entityID = getValue(paramsObj, `level${parseInt(parent_level) - 1}`, "")
  //     ? getValue(paramsObj, `level${parseInt(parent_level) - 1}`, "").split(
  //         "_"
  //       )[0]
  //     : null;

  //   if (!val) {
  //     getEntityList(entity_group, entityID, "");
  //     let length = Object.keys(paramsObj).length;
  //     for (let i = parent_level; i <= length; i++) {
  //       delete paramsObj[`level${i}`];
  //     }
  //     let obj = {
  //       ...paramsObj,
  //     };
  //     setParamsObj(obj);
  //   } else {
  //     getEntityList(entity_group, entityID, val);
  //   }
  // };

  /* ---------------------------  Entity Mapping Filters  ----------------------------- */

  const [headerList, setHeaderList] = useState([]);
  const [headerLoading, setHeaderLoading] = useState(false);
  const [levelObj, setLevelObj] = useState<any>({});
  const [paramsObj, setParamsObj] = useState<any>({});

  const getHeaderList = async (paramsObj: any, index: number) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      status: params.status ? params.status : "",
      sort_by: params.sort_by,
    };
    // let queryRequest = QueryRequestHelper(payload);
    let payloadObj = await getPayload();
    let queryRequest = QueryRequestHelper({ ...payload, ...payloadObj });
    try {
      let resp = await getEntityGroups(queryRequest);
      if (resp) {
        setHeaderList(getValue(resp, `data.entityGroups`, []));
        var result: any = {};
        for (
          let i = 0;
          i < getValue(resp, `data.entityGroups.length`, 0);
          i++
        ) {
          result[
            `${getValue(resp, `data.entityGroups[${i}].group_level`, "")}`
          ] = { [getValue(resp, `data.entityGroups[${i}].id`, "")]: {} };
        }
        if (Object.keys(levelObj).length === 0) {
          for (let x in result) {
            let keys = Object.keys(result[x])[0];
            levelObj[keys] = {};
          }
        }
        let list =
          Object.values(paramsObj).length > 0 ? Object.values(paramsObj) : [];
        if (getValue(list, `length`, 0) > 0) {
          getEntityList(
            getValue(paramsObj, `level1`, "").split("_")[1],

            `level${getValue(
              resp,
              `data.entityGroups[${0}].group_level`,
              "",
            )}` === `level1`
              ? ""
              : getValue(paramsObj, `level1`, "").split("_")[0],
            "",
            getValue(paramsObj, `level1`, "").split("_")[2],
          );
          list.map((item: any, _index: number) => {
            let findNextLevelInfo = getValue(
              resp,
              `data.entityGroups`,
              [],
            ).filter(
              (ite: any) =>
                ite.group_level === parseInt(item.split("_")[2]) + 1,
            );
            return getEntityList(
              getValue(findNextLevelInfo, `[${0}].id`, ""),
              item.split("_")[0],
              "",
              getValue(findNextLevelInfo, `[${0}].group_level`, ""),
            );
          });
        } else {
          getEntityList(
            getValue(resp, `data.entityGroups[${0}].id`, ""),
            null,
            "",
            getValue(resp, `data.entityGroups[${0}].group_level`, ""),
          );
        }
        setHeaderLoading(false);
      } else {
        setHeaderLoading(false);
      }
    } catch (error) {
      setHeaderLoading(false);
    }
  };

  const [childEntityList, setChildEntityList] = useState<any>({});
  const [childEntityLoading, setChildEntityLoading] = useState(false);
  const getEntityList = async (
    id: string,
    entity_parent: any,
    search_text: string,
    group_level: string,
  ) => {
    if (id) {
      let payload = {
        entity_group: group_level,
        entity_parent: entity_parent,
        limit: 10,
        search_text: search_text,
        id: id,
      };
      // let queryRequest = QueryRequestHelper(payload);
      let payloadObj = await getPayload();
      let queryRequest = QueryRequestHelper({ ...payload, ...payloadObj });
      setChildEntityLoading(true);
      try {
        let resp = await getATChildEntityGroups(queryRequest);
        if (resp) {
          levelObj[id] = getValue(resp, `data`, []).map((item: any) => ({
            ...item,
            id: getValue(item, `entity_id`, ""),
            value: getValue(item, `entity_name`, ""),
            label: getValue(item, `entity_name`, ""),
          }));
          setLevelObj({ ...levelObj });
          setChildEntityLoading(false);
        } else {
          setChildEntityLoading(false);
        }
      } catch (error) {
        setChildEntityLoading(false);
      }
    } else {
      // toast.error("You have Reached Maximum Levels");
    }
  };

  const handleClickEntity = (
    entity_id: any,
    group_id: any,
    group_level: any,
    headerIndex: number,
  ) => {
    //user selected level
    let userLevel = `${entity_id}_${group_id}_${group_level}`;
    let payload = { ...paramsObj };
    let selectedLevels =
      Object.values(payload).length > 0 ? Object.values(payload) : [];
    if (!selectedLevels.includes(userLevel)) {
      // appending child entity list that are presented in URL Params
      var result = Object.entries(childEntityList);
      var myNewArray: any =
        getValue(result, `length`, 0) > 0
          ? result.filter(function (item, index) {
              return index + 1 <= group_level;
            })
          : [];
      let obj: any = {};
      if (getValue(myNewArray, `length`, 0) > 0) {
        myNewArray.map((item: any) => {
          obj[item[0]] = item[1];
        });
      }
      setChildEntityList(obj);

      //deleting params if grater then current level selected by the user
      for (let i = group_level + 1; i < 10; i++) {
        delete paramsObj[`level${i}`];
      }

      // replacing url param if it have same group level / else we can add new one
      let checkIfAlreadyExist =
        Object.keys(payload).length > 0
          ? Object.keys(payload).includes(`level${group_level}`)
          : false;
      if (checkIfAlreadyExist) {
        delete paramsObj[`level${group_level}`];
        let obj = {
          ...paramsObj,
          // checkpoint_id: selectedIDs,
          [`level${group_level}`]: `${entity_id}_${group_id}_${group_level}`,
        };
        setParamsObj(obj);
        getHeaderList(obj, headerIndex);
        // let queryRequest = QueryRequestHelper(obj);
        // navigate(`${window.location.pathname}?${queryRequest}`);
      } else {
        let obj = {
          ...paramsObj,
          // checkpoint_id: selectedIDs,
          [`level${group_level}`]: `${entity_id}_${group_id}_${group_level}`,
        };
        setParamsObj(obj);
        getHeaderList(obj, headerIndex);
        // let queryRequest = QueryRequestHelper(obj);
        // navigate(`${window.location.pathname}?${queryRequest}`);
      }
    } else {
      // toast.error("Already selected");
    }
  };
  const handleChangeEntity = (
    val: string,
    entity_group: string,
    parent_level: any,
    index: number,
  ) => {
    let entityID = getValue(paramsObj, `level${parseInt(parent_level) - 1}`, "")
      ? getValue(paramsObj, `level${parseInt(parent_level) - 1}`, "").split(
          "_",
        )[0]
      : null;

    if (!val) {
      getEntityList(entity_group, entityID, "", parent_level);
      let length = Object.keys(paramsObj).length;
      for (let i = parent_level; i <= length; i++) {
        delete paramsObj[`level${i}`];
      }
      let obj = {
        ...paramsObj,
      };
      setParamsObj(obj);
    } else {
      getEntityList(entity_group, entityID, val, parent_level);
    }
  };

  /* -----------------------------  Executor  ------------------------------ */
  const [executorList, setExecutorList] = useState([]);
  const [executorLoading, setExecutorLoading] = useState(false);
  const [selectedExecutor, setSelectedExecutor] = useState<any>("");
  const getExecutorList = async (search: string, id: string) => {
    try {
      setResetInput(false);
      let user: any = JSON.parse(getValue(localStorage, `user`, ""));
      let payload: any = {
        page_no: 1,
        page_size: 10,
        search_text: search,
        user_type: "CLIENT",
        org_id: getValue(user, `org_id`, ""),
        id: id,
      };
      // let queryRequest = QueryRequestHelper(payload);
      let payloadObj = await getPayload();
      let queryRequest = QueryRequestHelper({ ...payload, ...payloadObj });
      setExecutorLoading(true);
      let resp = await getATExecutorUsers(queryRequest);
      if (resp) {
        setExecutorLoading(false);
        setExecutorList(
          getValue(resp, `data`, []).map((item: any) => ({
            ...item,
            id: getValue(item, `executor_id`, ""),
            value:
              getValue(item, `executor_first_name`, "") +
              " " +
              getValue(item, `executor_last_name`, ""),
            label:
              getValue(item, `executor_first_name`, "") +
              " " +
              getValue(item, `executor_last_name`, ""),
          })),
        );
      } else {
        setExecutorLoading(false);
      }
    } catch (error) {
      setExecutorLoading(false);
    }
    if (!search) {
      setValue(request, `executor`, "");
    }
  };

  /* --------------------------------  Evaluator  ------------------------------ */
  const [evaluatorList, setEvaluatorList] = useState([]);
  const [EvaluatorLoading, setEvaluatorLoading] = useState(false);
  const [selectedEvaluator, setSelectedEvaluator] = useState<any>("");
  const getEvaluator = async (search: string, id: string) => {
    try {
      setResetInput(false);
      let user: any = JSON.parse(getValue(localStorage, `user`, ""));
      let payload: any = {
        page_no: 1,
        page_size: 10,
        search_text: search,
        user_type: "CLIENT",
        org_id: getValue(user, `org_id`, ""),
        id: id,
      };
      // let queryRequest = QueryRequestHelper(payload);
      let payloadObj = await getPayload();
      let queryRequest = QueryRequestHelper({ ...payload, ...payloadObj });
      setEvaluatorLoading(true);
      let resp = await getATEvaluatorUsers(queryRequest);
      if (resp) {
        setEvaluatorLoading(false);
        setEvaluatorList(
          getValue(resp, `data`, []).map((item: any) => ({
            ...item,
            id: getValue(item, `evaluator_id`, ""),
            value:
              getValue(item, `evaluator_first_name`, "") +
              " " +
              getValue(item, `evaluator_last_name`, ""),
            label:
              getValue(item, `evaluator_first_name`, "") +
              " " +
              getValue(item, `evaluator_last_name`, ""),
          })),
        );
      } else {
        setEvaluatorLoading(false);
      }
    } catch (error) {
      setEvaluatorLoading(false);
    }

    if (!search) {
      setValue(request, `evaluator`, "");
    }
  };

  /* -----------------------------  FunctionHead  ------------------------------ */
  const [FunctionHead, setFunctionHead] = useState([]);
  const [FunctionHeadLoading, setFunctionHeadLoading] = useState(false);
  const [selectedFunctionHead, setSelectedFunctionHead] = useState<any>("");
  const getFunctionHead = async (search: string, id: string) => {
    try {
      setResetInput(false);
      let user: any = JSON.parse(getValue(localStorage, `user`, ""));
      let payload: any = {
        page_no: 1,
        page_size: 10,
        search_text: search,
        user_type: "CLIENT",
        org_id: getValue(user, `org_id`, ""),
        id: id,
      };
      // let queryRequest = QueryRequestHelper(payload);
      let payloadObj = await getPayload();
      let queryRequest = QueryRequestHelper({ ...payload, ...payloadObj });
      setFunctionHeadLoading(true);
      let resp = await getATFunctionHeadUsers(queryRequest);
      if (resp) {
        setFunctionHeadLoading(false);
        setFunctionHead(
          getValue(resp, `data`, []).map((item: any) => ({
            ...item,
            id: getValue(item, `function_head_id`, ""),
            value:
              getValue(item, `function_head_first_name`, "") +
              " " +
              getValue(item, `function_head_last_name`, ""),
            label:
              getValue(item, `function_head_first_name`, "") +
              " " +
              getValue(item, `function_head_last_name`, ""),
          })),
        );
      } else {
        setFunctionHeadLoading(false);
      }
    } catch (error) {
      setFunctionHeadLoading(false);
    }
    if (!search) {
      setValue(request, `function_head`, "");
    }
  };

  /* ---------------------------  Onchange Smart filter  ----------------------------- */

  const handleChangeSelect = (e: any, type: string) => {
    if (type === "country_id") {
      getStatesList(e.id);
      setStates([]);
      setCategoryOfLawList([]);
      setLegislationList([]);
      setRuleList([]);
      setRequest({
        ...request,
        country_id: e.id,
        state_id: "",
        category_of_law_id: "",
        legislation_id: "",
        legislation_rule_id: "",
      });
    }
    if (type === "state_id") {
      if (!getValue(e, `id`, "")) {
        setValue(request, `id`, "");
        setRequest({
          ...request,
          state_id: "",
          category_of_law_id: "",
          legislation_id: "",
          legislation_rule_id: "",
        });
        setCategoryOfLawList([]);
        setLegislationList([]);
        setRuleList([]);
      } else {
        setRequest({
          ...request,
          state_id: getValue(e, `id`, "") ? e.id : "",
          category_of_law_id: "",
          legislation_id: "",
          legislation_rule_id: "",
        });
        getCategoryLawList("", e.id, "");
      }
    }
    if (type === "category_of_law_id") {
      if (!getValue(e, `id`, "")) {
        setRequest({
          ...request,
          category_of_law_id: "",
          legislation_id: "",
          legislation_rule_id: "",
        });
        setLegislationList([]);
        setRuleList([]);
      } else {
        setRequest({
          ...request,
          category_of_law_id: getValue(e, `id`, "") ? e.id : "",
        });
        getLegislationList("", getValue(request, `state_id`, ""), e.id, "");
      }
    }
    if (type === "legislation_id") {
      if (!getValue(e, `id`, "")) {
        setRequest({
          ...request,
          legislation_id: "",
          legislation_rule_id: "",
        });
        setRuleList([]);
      } else {
        getLegislationRuleList("", getValue(e, `id`, "") ? e.id : "", "");
        setRequest({
          ...request,
          legislation_id: getValue(e, `id`, "") ? e.id : "",
          legislation_rule_id: "",
        });
      }
    }
    if (type === "legislation_rule_id") {
      if (!getValue(e, `id`, "")) {
        setRequest({
          ...request,
          legislation_rule_id: "",
        });
      } else {
        setRequest({
          ...request,
          legislation_rule_id: getValue(e, `id`, "") ? e.id : "",
        });
      }
    }
    if (type === "frequency_id") {
      setRequest({
        ...request,
        frequency_id: getValue(e, `id`, "") ? e.id : "",
      });
    }
    if (type === "checkpoint_id") {
      setRequest({
        ...request,
        checkpoint_id: getValue(e, `id`, "") ? e.id : "",
      });
    }
    if (type === "executor") {
      setRequest({
        ...request,
        executor: getValue(e, `id`, "") ? e.id : "",
      });
    }
    if (type === "evaluator") {
      setRequest({
        ...request,
        evaluator: getValue(e, `id`, "") ? e.id : "",
      });
    }
    if (type === "function_head") {
      setRequest({
        ...request,
        function_head: getValue(e, `id`, "") ? e.id : "",
      });
    }
  };

  const handleSubmitSmartFilter = () => {
    let selectedSmartFilterIdsPayload = JSON.parse(
      JSON.stringify(selectedSmartFilterIds),
    );
    let levelObj: any = {};
    //finding only levels params if it presented in URL
    for (let i = 1; i < 11; i++) {
      if (getValue(paramsObj, `level${i}`, "")) {
        levelObj[`level${i}`] = getValue(paramsObj, `level${i}`, "");
      }
    }
    if (
      getValue(request, `country_id`, "")
      // getValue(request, `state_id`, "")
      // && getValue(request, `category_of_law_id`, "") &&
      // getValue(request, `legislation_id`, "") &&
      // getValue(request, `legislation_rule_id`, "")
    ) {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());
      let payload: any = {
        ...params,
        page_no: params.page_no,
        country_id: getValue(request, `country_id`, ""),
        state_id: getValue(request, `state_id`, ""),
        category_of_law_id: getValue(request, `category_of_law_id`, ""),
        legislation_id: getValue(request, `legislation_id`, ""),
        legislation_rule_id: getValue(request, `legislation_rule_id`, ""),
        search_text: getValue(params, `search_text`, ""),
        limit: getValue(params, `limit`, ""),
        event_id: getValue(request, `event_id`, ""),
        sub_event_id: getValue(request, `sub_event_id`, ""),
        executor: getValue(request, `executor`, ""),
        evaluator: getValue(request, `evaluator`, ""),
        function_head: getValue(request, `function_head`, ""),

        smart_filter_tags:
          selectedSmartFilterIdsPayload.length > 0
            ? selectedSmartFilterIdsPayload.map((item: object) =>
                getValue(item, `id`, ""),
              )
            : [],
      };
      let queryRequest = QueryRequestHelper({ ...payload, ...levelObj });
      navigate(`${window.location.pathname}?${queryRequest}`);
      handleFilter();
    } else {
      toast.error("All fields are mandatory");
    }
  };
  // console.log(request);
  let country_ID =
    getValue(countryList, `length`, 0) > 0 &&
    countryList.filter(
      (item: object) =>
        getValue(item, `id`, "") == getValue(request, `country_id`, ""),
    );
  let state_ID =
    getValue(states, `length`, 0) > 0 &&
    states.filter(
      (item: object) =>
        getValue(item, `id`, "") == getValue(request, `state_id`, ""),
    );
  let cat_ID =
    getValue(categoryOfLawList, `length`, 0) > 0 &&
    categoryOfLawList.filter(
      (item: object) =>
        getValue(item, `id`, "") == getValue(request, `category_of_law_id`, ""),
    );
  let leg_ID =
    getValue(legislationList, `length`, 0) > 0 &&
    legislationList.filter(
      (item: object) =>
        getValue(item, `id`, "") == getValue(request, `legislation_id`, ""),
    );
  let rule_ID =
    getValue(ruleList, `length`, 0) > 0 &&
    ruleList.filter(
      (item: object) =>
        getValue(item, `id`, "") ==
        getValue(request, `legislation_rule_id`, ""),
    );
  let executor_ID =
    getValue(executorList, `length`, 0) > 0 &&
    executorList.filter(
      (item: object) =>
        getValue(item, `id`, "") == getValue(request, `executor`, ""),
    );
  let evaluator_ID =
    getValue(evaluatorList, `length`, 0) > 0 &&
    evaluatorList.filter(
      (item: object) =>
        getValue(item, `id`, "") == getValue(request, `evaluator`, ""),
    );
  let function_head_ID =
    getValue(FunctionHead, `length`, 0) > 0 &&
    FunctionHead.filter(
      (item: object) =>
        getValue(item, `id`, "") == getValue(request, `function_head`, ""),
    );

  const handleChangeActiveStatus = async (value: string) => {
    try {
      let resp = await adminBulkUpdateStatus({
        ids: selectedIDs,
        is_active: value === "active" ? true : false,
      });
      if (resp) {
        toast.success(getValue(resp, `message`, ""));
        setSelectedIDs([]);
        getData();
      } else {
        getData();
      }
    } catch (error) {}
  };
  const urlSearchParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlSearchParams.entries());
  const [check, setCheck] = useState(false);
  const handleRemoveNavItems = () => {
    setCheck(!check);
    setSelectedIDs([]);
  };

  /* ---------------------------  Configure Popup  ----------------------------- */
  const [isOpen, setIsOpen] = useState(false);
  const handleModal = () => {
    // setIsOpen(!isOpen)
    let payload = {
      ...params,
      self_compliance_ids: selectedIDs,
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`/repository/checkpoint/assign-task-configure?${queryRequest}`);
  };

  let findDataOfIDs =
    getValue(list, `length`, 0) > 0
      ? list.filter((item) => {
          return selectedIDs.includes(getValue(item, `id`, ""));
        })
      : [];

  let findNotConfiguredIds =
    getValue(findDataOfIDs, `length`, 0) > 0
      ? findDataOfIDs.filter((item) => !getValue(item, `is_configured`, false))
      : [];
  /* ---------------------------  Frequency Section ------------------------------------ */

  const [frequencyList, setFrequencyList] = useState([]);
  const [searchFrequencyLoading, setSearchFrequencyLoading] = useState(false);
  const handleTriggerFrequency = (value: string) => {
    if (value) {
      getFrequency("", value);
    } else {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());
      delete params.frequency_id;
      let payload = {
        ...params,
        page_no: 1,
      };
      let queryRequest = QueryRequestHelper(payload);
      navigate(`${window.location.pathname}?${queryRequest}`);
    }
  };
  const getFrequency = async (id: string, value: string) => {
    try {
      let payload: any = {
        page_no: 1,
        page_size: 10,
        is_active: true,
        search_text: value,
        id: id,
        group_code: "frequency",
      };
      let queryRequest = QueryRequestHelper(payload);
      setSearchFrequencyLoading(true);
      let resp = await getSmartFilterListManagementList(queryRequest);
      if (resp) {
        setSearchFrequencyLoading(false);
        setFrequencyList(
          getValue(resp, `data.listItems`, []).map((item: object) => ({
            ...item,
            value: getValue(item, `text`, ""),
            label: getValue(item, `text`, ""),
          })),
        );
      } else {
        setSearchFrequencyLoading(false);
      }
    } catch (error) {
      setSearchFrequencyLoading(false);
    }
  };

  /* ---------------------------  Configure Section ------------------------------------ */

  const [configureStatus] = useState([
    { value: "configured", label: "Configured" },
    { value: "not_configured", label: "Not Configured" },
  ]);
  const [activationStatus] = useState([
    { value: "DRAFT", label: "Draft" },
    { value: "ACTIVE", label: "Active" },
    { value: "ARCHIVED", label: "Archived" },
  ]);

  //   getSelfComplianceTaskList

  const [downloadLoading, setDownloadLoading] = useState(false);
  const handleDownload = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let selectedIDs: any = urlSearchParams.getAll("smart_filter_tags[]");
    let payload: any = {
      sort_by: params.sort_by,
      country_id: parseInt(getValue(params, `country_id`, "")),
      state_id: parseInt(getValue(params, `state_id`, "")),
      // category_of_law_id: await getSpecificCategoryLawById(
      //   getValue(params, `category_of_law_id`, "")
      // ),
      category_of_law_id: getValue(params, `category_of_law_id`, ""),
      legislation_id: getValue(params, `legislation_id`, ""),
      legislation_rule_id: getValue(params, `legislation_rule_id`, ""),
      event_id: parseInt(getValue(params, `event_id`, "")),
      sub_event_id: parseInt(getValue(params, `sub_event_id`, "")),
      smart_filter_tags: selectedIDs,
      compliance_type_id: getValue(params, `compliance_type_id`, ""),
      executor: getValue(params, `executor`, ""),
      evaluator: getValue(params, `evaluator`, ""),
      function_head: getValue(params, `function_head`, ""),
      activation_status: getValue(params, `activation_status`, ""),
      is_configured: getValue(params, `is_configured`, ""),
    };
    Object.keys(payload).forEach((key) => {
      if (!payload[key] || payload[key] === undefined) {
        delete payload[key];
      }
    });
    let levelObj: any = {};
    //finding only levels params if it presented in URL
    for (let i = 1; i < 11; i++) {
      if (getValue(paramsObj, `level${i}`, "")) {
        levelObj[`level_${i}`] = getValue(paramsObj, `level${i}`, "").split(
          "_",
        )[0];
      }
    }

    let obj = {
      ...payload,
      ...levelObj,
    };
    let queryRequest = QueryRequestHelper(obj);
    try {
      setDownloadLoading(true);
      let resp = await downloadSelfCompliance(queryRequest);
      if (resp) {
        handleDownloadOnClick(
          getValue(resp, `data.downloadUrl`, ""),
          "assign_task",
        );
        setDownloadLoading(false);
      } else {
        setDownloadLoading(false);
      }
    } catch (error) {
      setDownloadLoading(false);
    }
  };

  const handleDownloadSelfComplianceReport = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let selectedIDs: any = urlSearchParams.getAll("smart_filter_tags[]");
    let dates = params.date ? new Date(params.date) : new Date();
    var from_date = params.owner_due_date_from
      ? params.owner_due_date_from
      : new Date(dates.getFullYear(), dates.getMonth(), 1);
    var to_date = params.owner_due_date_to
      ? params.owner_due_date_to
      : new Date(dates.getFullYear(), dates.getMonth() + 1, 0);
    let payload: any = {
      sort_by: params.sort_by,
      country_id: parseInt(getValue(params, `country_id`, "")),
      state_id: parseInt(getValue(params, `state_id`, "")),
      category_of_law_id: getValue(params, `category_of_law_id`, ""),
      legislation_id: getValue(params, `legislation_id`, ""),
      legislation_rule_id: getValue(params, `legislation_rule_id`, ""),
      event_id: parseInt(getValue(params, `event_id`, "")),
      sub_event_id: parseInt(getValue(params, `sub_event_id`, "")),
      smart_filter_tags: selectedIDs,
      executor: getValue(params, `executor`, ""),
      evaluator: getValue(params, `evaluator`, ""),
      function_head: getValue(params, `function_head`, ""),
      report_type: "CHECKPOINT_ASSIGNED_TASK",
      status: getValue(params, `status`, "")
        ? getValue(params, `status`, "")
        : "active",
      report_name: (
        convertDateAsString(from_date) +
        " " +
        "to" +
        " " +
        convertDateAsString(to_date)
      ).toString(),
      compliance_status: getValue(params, `compliance_status`, ""),
      compliance_type_id: getValue(params, `compliance_type_id`, ""),
      activation_status: getValue(params, `activation_status`, ""),
      is_configured: getValue(params, `is_configured`, ""),
      frequency_id: getValue(params, `frequency_id`, ""),
    };
    Object.keys(payload).forEach((key) => {
      if (!payload[key] || payload[key] === undefined) {
        delete payload[key];
      }
    });
    let levelObj: any = {};
    //finding only levels params if it presented in URL
    for (let i = 1; i < 11; i++) {
      if (getValue(paramsObj, `level${i}`, "")) {
        levelObj[`level_${i}`] = getValue(paramsObj, `level${i}`, "").split(
          "_",
        )[0];
      }
    }
    // let queryRequest = QueryRequestHelper({ ...payload, ...levelObj });
    setDownloadLoading(true);
    try {
      let resp = await downloadAssignedTaskReports({
        ...payload,
        ...levelObj,
      });
      if (resp) {
        setDownloadLoading(false);
        toast.success(getValue(resp, `message`, ""));
        navigate(`/self-compliance-logs/CHECKPOINT_ASSIGNED_TASK`);
      } else {
        setDownloadLoading(false);
      }
    } catch (error) {
      setDownloadLoading(false);
    }
  };
  // Filter Popup Selection
  // const [filterIsOpen, setFilterIsOpen] = useState(false);

  // const handleFilter = () => {
  //   setFilterIsOpen(!filterIsOpen);
  // };

  const handleNavigateLogs = () => {
    navigate(`/self-compliance-logs/CHECKPOINT_ASSIGNED_TASK`);
  };
  return (
    <DashboardLayout
      permissions={getValue(props, `tabPermissionList`, [])}
      subTabPermissionList={getValue(props, `subTabPermissionList`, [])}
    >
      {!isLoading &&
      !getValue(props, `subTabPermissionList`, []).includes(
        "repository_checkpoint_assigned_tasks",
      ) ? (
        <NoAccessPage />
      ) : (
        <>
          {getValue(selectedIDs, `length`, 0) > 0 && (
            <NavigationBar
              selectedIDs={selectedIDs}
              // isMarkInactiveSectionVisible={true}
              handleChangeActiveStatus={handleChangeActiveStatus}
              text={"MARK INACTIVE"}
              handleRemoveNavItems={handleRemoveNavItems}
              handleNavigate={handleNavigate}
              permissions={props.permissions}
              licenseIDs={licenseIDs}
              // assignTask
              masterNav={"false"}
              assignedTaskActive={
                getValue(props, `permissions`, []).includes("update")
                  ? true
                  : false
              }
              filterOptions={filterOptions}
              handleUpdateStatus={handleUpdateStatus}
              handleModal={handleModal}
              findNotConfiguredIds={
                getValue(findNotConfiguredIds, `length`, 0) > 0 ? true : false
              }
            />
          )}
          <div className="dashboard-wrapper__header d-flex align-items-center justify-content-between d-none">
            <h4 className="dashbaord-wrapper__header-title">Assigned Tasks</h4>
            <div
              className=" d-block justify-content-center cursor-pointer"
              onClick={handleDownload}
            >
              <img
                src="/images/download-gray.svg"
                style={{
                  height: "24px",
                  width: "24px",
                  margin: "0px auto",
                  marginLeft: "22px",
                }}
              />
              <p style={{ fontSize: "10px" }}>
                {downloadLoading ? "Please wait..." : "DOWNLOAD"}
              </p>
            </div>
          </div>

          <div className="dashboard-wrapper__header d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center">
              <div className="header-parent-icon-holder">
                <MenuRepositorySvgComponent />
              </div>

              <div className="title-wrapper">
                <h6 className="dashbaord-wrapper__header-parent-title">
                  Checkpoint
                </h6>
                <h4 className="dashbaord-wrapper__header-title">
                  Assigned Tasks
                </h4>
              </div>
            </div>

            <div className="d-flex align-items-center">
              <RightMenuHeaders
                monthYear={false}
                //search
                isSearch={true}
                searchInput={search_text}
                showSearchTextbox={showSearchTextbox}
                toggleSearch={toggleSearch}
                toggleSearchClose={toggleSearchClose}
                handleChangeSearch={handleChangeSearch}
                //smartFilter
                smartFilter={true}
                handleFilter={handleFilter}
                downloadAssignTask={true}
                handleDownload={handleDownloadSelfComplianceReport}
                downloadLoading={downloadLoading}
                //logs section
                viewDownloadedSelfComplianceReports={true}
                handleNavigateLogs={handleNavigateLogs}
                //Line Seperator of button
                lineSeperator={true}
                selectedFilterCount={countKeysWithValues(params)}
              />
            </div>
          </div>

          <div
            className={`main-page-layout-wrapper has-module-filter`}
            id={
              getValue(selectedIDs, `length`, 0) > 0
                ? "blueNavigationVisible"
                : ""
            }
          >
            <div className="admin-wrapper position-relative">
              <div className="admin-wrapper position-relative d-none">
                <SearchHeader
                  route={"/support/details"}
                  searchInput={search_text}
                  showSearchTextbox={showSearchTextbox}
                  toggleSearch={toggleSearch}
                  toggleSearchClose={toggleSearchClose}
                  handleChangeSearch={handleChangeSearch}
                  isBulkUploadVisible={false}
                  smartFilter={true}
                  setFilterFormVisibility={() => {
                    setFilterVisibility(!isFilterVisible);
                  }}
                  add={"false"}
                  isFilterVisible={isFilterVisible}
                  peComplianceList={peComplianceList}
                  handleChangeStatus={handleChangeStatus}
                  //frequency Filter
                  filterFrequency
                  frequencyList={frequencyList}
                  handleTriggerFrequency={handleTriggerFrequency}
                  searchFrequencyLoading={searchFrequencyLoading}
                  filterConfigure
                  configureStatus={configureStatus}
                  activeStatus
                  activationStatus={activationStatus}
                  // filterCompliance
                  // downloadSelfComplianceReport
                  filterIsOpen={filterIsOpen}
                  handleFilter={() => {
                    setFilterIsOpen(!filterIsOpen);
                  }}
                />
              </div>

              <div>
                <ModuleFilter
                  peComplianceList={peComplianceList}
                  handleChangeStatus={handleChangeStatus}
                  filterFrequency
                  frequencyList={frequencyList}
                  handleTriggerFrequency={handleTriggerFrequency}
                  searchFrequencyLoading={searchFrequencyLoading}
                  filterConfigure
                  configureStatus={configureStatus}
                  activeStatus
                  activationStatus={activationStatus}
                />
              </div>

              {/* {isFilterVisible && ( */}
              <AssignTaskFilterForm
                setFilterFormVisibility={() => {
                  setFilterVisibility(!isFilterVisible);
                }}
                countryList={countryList}
                states={states}
                handleChangeSelect={handleChangeSelect}
                additionalFilter={true}
                country_ID={country_ID}
                state_ID={state_ID}
                reset={reset}
                handleSubmitSmartFilter={handleSubmitSmartFilter}
                smartFilterList={smartFilterList}
                handleChangeSelectMulti={handleChangeSelectMulti}
                selectedSmartFilterIds={selectedSmartFilterIds}
                events={true}
                request={request}
                //dynamic filter ( Custom Input Select Dropdown)
                //----> category of law
                categoryOfLawList={categoryOfLawList}
                getCategoryLawList={getCategoryLawList}
                categoryLawLoading={categoryLawLoading}
                cat_ID={cat_ID}
                //----> legislation
                legislationList={legislationList}
                getLegislationList={getLegislationList}
                legislationLoading={legislationLoading}
                leg_ID={leg_ID}
                //----> legislation rule
                ruleList={ruleList}
                getLegislationRuleList={getLegislationRuleList}
                rule_ID={rule_ID}
                legislationRuleLoading={legislationRuleLoading}
                resetInput={resetInput}
                //-----> Entity Mapping Filter
                headerList={headerList}
                headerLoading={headerLoading}
                levelObj={levelObj}
                childEntityLoading={childEntityLoading}
                handleClickEntity={handleClickEntity}
                urlParams={paramsObj}
                handleChangeEntity={handleChangeEntity}
                //----> Executor
                executorList={executorList}
                executor_ID={executor_ID}
                executorLoading={executorLoading}
                getExecutorList={getExecutorList}
                //----> Evaluator
                evaluator_ID={evaluator_ID}
                evaluatorList={evaluatorList}
                EvaluatorLoading={EvaluatorLoading}
                getEvaluator={getEvaluator}
                //----> Function Head
                function_head_ID={function_head_ID}
                FunctionHead={FunctionHead}
                FunctionHeadLoading={FunctionHeadLoading}
                getFunctionHead={getFunctionHead}
                filterIsOpen={filterIsOpen}
                handleFilter={handleFilter}
                moduleName={"Checkpoint"}
                subModuleName={"Assigned Tasks"}
              />
              {/* )} */}

              {isLoading || !props.permissionAPITriggered ? (
                <Loader />
              ) : list.length > 0 ? (
                <ScrollableReactTable
                  columns={columns}
                  data={list}
                  getTableState={getTableState}
                  rowClick={rowClick}
                  check={check}
                  selectedIDs={selectedIDs}
                  getTrProps={getTrProps}
                />
              ) : (
                <>
                  {Object.keys(params).length !== 0 ? (
                    <>
                      <CheckpointAssignedTaskNotfound />
                    </>
                  ) : (
                    <CheckpointAssignedTaskNotfound />
                  )}
                </>
              )}
            </div>
            <FooterWrapper
              list={list}
              totalCount={totalCount}
              limit={limit}
              page_no={page_no}
              handleChangePagination={handleChangePagination}
              handleChangeLimit={handleChangeLimit}
            />
          </div>
          <DeleteModal
            isOpen={isDelete}
            handleModal={handleDelete}
            handleSubmit={handleDeleteFunction}
            deleteValue={deleteValue}
          />
        </>
      )}
    </DashboardLayout>
  );
};
export default AssignedTasks;
